import styled from "styled-components";

export const Wrapper = styled.div`
    padding-top: 88px;
`;

export const Text = styled.p`
    color: rgba(255, 219, 219, 0.60);
    font-size: 24px;
    font-weight: 700;
`;